export default __webpack_public_path__ + "static/media/elastic-svgrepo-com.214702eb.svg";